//#region types
import { QuotationDateGroupProps } from "models/propTypes/quotationPropTypes";
import { TranslationKeys } from "translations";
import { DateInputProps } from "models/propTypes/wintFormPropsTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { HorizontalFormField, DateInput, GroupSection } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function DateGroup({ connect }: QuotationDateGroupProps) {
  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Dates)}
      icon={IconDefinitionConstants.WCalendar}
    >
      <HorizontalFormField<DateInputProps>
        Component={DateInput}
        {...connect("otherSettings.invoiceDate")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.QuotationDate)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Quotation.QuotationDateDescription
        )}
      />
      <HorizontalFormField<DateInputProps>
        Component={DateInput}
        {...connect("otherSettings.dueDate")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.ExpirationDate)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Quotation.ExpirationDateDescription
        )}
      />
    </GroupSection>
  );
}

export default DateGroup;
